const list = (data) => {
    let tag = 'ul';
    if (data.style === 'ordered') {
        tag = 'ol';
    }

    let val = `<${tag}>`
    data.items.forEach(items => {
        val += `<li>${items}</li>`
    })
    val += `</${tag}>`
    return val
}

module.exports = list